import React from "react";
import Switch from "@mui/material/Switch";
//import makeStyles from '@mui/style/makeStyles';
//import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";
  
export default function MUISwitch({checkedA,handleStateChange,setEnergyCostBudget,energycostbudget,widgetprop}) {
    //console.log("IN MUISwitch I AM IN");
    
    //{console.log("props.widgetprop.props.extended.switch_properties.backgroundcolor,",widgetprop.props.extended.switch_properties.switchthumb.color)}
    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
      width: widgetprop.props.extended.switch_properties.width,
      height: "28px",
      padding: "0px",
      justifyContent:"center",
      
      '& .MuiSwitch-switchBase': {
        color: "#B5BFBC",
        padding: "0px",
        justifyContent:"center",
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: "#005C8E",     
        },
      },
      '& .MuiSwitch-thumb': {
          color: "#E0E0E0",
          width: "20px",
          height: "20px", 
          margin: "4px 5px 4px 5px",
          padding:"0px"
      },
      '& .MuiSwitch-track': {
          borderRadius: "20px",
          backgroundColor:"#005C8E",
          justifyContent:"center",
          opacity: "1 !important",
          '&:after': {
            color: "#E0E0E0",
            fontSize: "11px",
            marginLeft:"23px",
            marginTop:"10px",
            position: "relative",
            content:(energycostbudget==false)?'"INR"':'""'
        },
        
      },
      '& .Mui-checked': {
          color: "#005C8E",
          transform: "translateX(3px) !important",
          transitionDuration: '4s',
          transitionDelay:'10s',
          '&: before': {
            color: "#E0E0E0",
            fontSize: "11px",
            position: "relative",
            marginLeft:"3px",
            marginBottom:"2px",
            content:'"kWh"'
        },
      },
    }));

    function handleChangeEnergyCostBudget(event){
        setEnergyCostBudget(!energycostbudget);
    };

    return (
      <div style={{}}>
            <MaterialUISwitch
                    checked={energycostbudget}
                    onChange={handleChangeEnergyCostBudget}
                    name="Name"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                    sx={{marginBottom:0}}
            />                           
      </div>
    );
  }